/* eslint-disable functional/no-throw-statement */
/* eslint-disable functional/no-try-statement */
import { Auth0Provider } from "@equipmentshare/auth0-react";
import React from "react";
import {
  Auth0ApplicationConfigurationType,
  getAuth0ApplicationConfiguration,
} from "~/Auth";
import { isLocalDevelopment } from "~/Context";
import { AuthenticationRouter } from "./AuthenticationRouter";
import { AuthLoading } from "./AuthLoading";
import { HelmetProvider } from '@equipmentshare/ds2-helmet'

import favicon from "~/images/favicon.png"

export type Authorization = {
  readonly jwt?: string;
  readonly companyId?: number;
  readonly userId?: number;
  readonly securityLevelId?: number;
};

export function AppAuthenticationWrapper() {
  const {
    audience,
    clientId,
    domain,
    redirectUri,
  }: Auth0ApplicationConfigurationType = getAuth0ApplicationConfiguration();

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      audience={audience}
      redirectUri={redirectUri}
      // In-memory caching means every page reload silently re-authenticates
      // against Auth0, which shows a consent screen on localhost (though not on
      // staging/production) — see fleet-ui's asset-management/auth-provider.tsx
      // for the same fix. Kept memory-only outside local dev.
      cacheLocation={isLocalDevelopment() ? "localstorage" : "memory"}
      useRefreshTokens={isLocalDevelopment()}
      withAuthenticationRequiredOptions={{
        onRedirecting: () => <AuthLoading />,
      }}
    >
      <HelmetProvider appName="E-Logs" faviconPath={favicon}>
        <AuthenticationRouter />
      </HelmetProvider>
    </Auth0Provider>
  );
}
